import { render } from "./DigestPage.vue?vue&type=template&id=6641ea3a&scoped=true&ts=true"
import script from "./DigestPage.vue?vue&type=script&lang=ts"
export * from "./DigestPage.vue?vue&type=script&lang=ts"

import "./DigestPage.vue?vue&type=style&index=0&id=6641ea3a&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6641ea3a"]])

export default __exports__